type TOrderListCardImagesItem = {
  createAt: string;
  type: string;
  url: string;
  _id: string;
};

export type TOrderListCard = {
  productType: 'gift_card';
  cardType: 'physical' | 'digital';
  nominal: number;
  count: number;
  cardUsage?: 'yourself' | 'gift';
  email?: string;
  whenDeliver?: 'now' | 'later';
  dateTime?: string;
  recipientName?: string;
  senderName?: string;
  message?: string;
  phone?: string;
  product: {
    _id: string;
    name: {
      [key: string]: string;
    };
    images: TOrderListCardImagesItem[];
  };
};

type TOrderInfoGiftCard = {
  customerPhone: string;
  customerEmail: string;
  customerFullName: string;
  deliveryType?: 'pickup' | 'delivery';
  comment?: string;
  address?: string;
  addressMetadata?: string;
  deliveryComment?: string;
  deliveryPrice?: number;
};

export type TOrderListItem = {
  orderType: 'gift_card_digital' | 'gift_card_physical';
  orderInfo: TOrderInfoGiftCard;
  items: Array<TOrderListCard>;
  _id: string;
  invoiceId: string;
  invoiceUrl: string;
  orderNumber: number;
  createdAt: string;
  paymentStatus: 'not_paid' | 'paid' | 'delivery' | 'completed' | 'canceled';
  status: string;
};

type TOrderList = {
  totalCount: number;
  data: TOrderListItem[];
};

type TOrderInvoice = {
  invoice_id: string;
  invoice_url: string;
};

export async function getOrderListData(page: number, token?: string): Promise<TOrderList> {
  const res = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/orders?limit=10&page=${page}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  const jsonData: TOrderList = await res.json();
  return jsonData;
}

export async function getOrderData(id: string, token?: string): Promise<TOrderListItem> {
  const res = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/orders/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  const jsonData: TOrderListItem = await res.json();
  return jsonData;
}

export async function cancelOrder(id: string, token?: string): Promise<void> {
  await fetch(`${process.env.REACT_APP_API_URL}/api/v1/orders/${id}/cancel`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export async function paymentOrder(id: string, token?: string): Promise<TOrderInvoice> {
  const res = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/orders/${id}/invoice`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  const jsonData: TOrderInvoice = await res.json();
  return jsonData;
}
